<template>
  <div
    :class="['skeleton-container', `gap-${gap}`, { 'animate-pulse': animate }]"
  >
    <div
      v-for="index in count"
      :key="index"
      :class="['skeleton', skeletonClasses]"
      :style="generateRandomStyle(index)"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps({
  animate: {
    type: Boolean,
    default: true,
  },
  width: {
    type: [String, Number],
    default: 'full',
  },
  height: {
    type: [String, Number],
    default: '3',
  },
  radius: {
    type: String,
    default: '',
  },
  count: {
    type: Number,
    default: 1,
  },
  gap: {
    type: [String, Number],
    default: '3',
  },
  randomize: {
    type: Boolean,
    default: false,
  },
  minWidth: {
    type: Number,
    default: 40,
  },
  maxWidth: {
    type: Number,
    default: 80,
  },
})

const randomNumber = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1) + min)
}

const generateRandomStyle = (index: number) => {
  if (!props.randomize) return {}
  return {
    width: `${randomNumber(props.minWidth, props.maxWidth)}%`,
    'animation-delay': `${index * 100}ms`,
  }
}

const skeletonClasses = computed(() => {
  const width = props.randomize ? '' : `w-${props.width}`
  const height = `h-${props.height}`
  const radius = props.radius ? `rounded-${props.radius}` : ''
  return [width, height, radius].join(' ')
})
</script>

<style lang="postcss" scoped>
.skeleton {
  @apply bg-gray-300;
}
.skeleton-container {
  @apply flex flex-col w-full;
}
</style>
